export * from './instructions.module';

export { InstructionsComponent } from './components/instructions.component';



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/instructions/index.ts